<div id="login-page" class="primary-background">
  <ng-container *ngIf="isInIframe; else loginform">
    <div class="login-page-iframe-view">
      <h6>{{ "currently_logged_out" | translation }}</h6>
      <h6>{{ "refresh_browser_log_back_in" | translation }}</h6>
    </div>
  </ng-container>
  <ng-template #loginform>
    <div id="login-form" class="align-center">
      <p-card>
        <p-card-body>
          <img id="school-logo" src="school-assets/school_logo.png" alt="" />
          <div id="error-wrapper">
            <p *ngIf="loginErrorMessage" id="error-msg">
              {{ loginErrorMessage }}
            </p>
          </div>
          <ng-container *ngIf="provideTotbChallenge">
            <p>Multi-factor Authentication</p>
            <p>Enter an MFA code to Complete Login</p>

            <form (keydown.enter)="submitChallenge('totb', $event)">
              <!-- <p-inputgroup> -->
                <input
                  [(ngModel)]="usercode"
                  [ngModelOptions]="{ standalone: true }"
                  pInputText
                  placeholder="MFA Code"
                  style="margin: 10px"

                />
                <!-- <button
                  *ngIf="showBackToMfaOptions"
                  class="login-page-button"
                  [disabled]="challengeSubmitted"
                  pButton
                  (click)="backToMFASelection()"
                  severity="primary"
                  style="border: none; margin: 10px"
                >
                  Back
                </button> -->
                <button
                  class="login-page-button"
                  pButton
                  (click)="submitChallenge('totb', $event)"
                  type="submit"
                  severity="primary"
                  style="border: none; margin: 10px"
                  [disabled]="!usercode || challengeSubmitted"
                >
                  Submit
                </button>
              <!-- </p-inputgroup> -->
              <!-- <div class="login-page-loading-wrapper">
                <div
                  class="align-center fa-2x loading-overlay"
                  *ngIf="challengeSubmitted"
                >
                  <scaffold-loading-animation></scaffold-loading-animation>
                </div>
              </div> -->
            </form>
          </ng-container>

          <ng-container *ngIf="provideSmsChallenge">
            <p>Multi-factor Authentication</p>
            <p>Provide the code from the text message to complete login</p>
            <form (keydown.enter)="submitChallenge('sms', $event)">
              <p-inputgroup>
                <input
                  [(ngModel)]="usercode"
                  [ngModelOptions]="{ standalone: true }"
                  pInputText
                  placeholder="MFA Code"
                />
                <!-- <button
                  class="login-page-button"
                  [disabled]="challengeSubmitted"
                  pButton
                  (click)="backToMFASelection()"
                  severity="primary"
                  style="border: none; margin: 10px"
                >
                  Back
                </button> -->
                <button
                  class="login-page-button"
                  pButton
                  (click)="submitChallenge('sms', $event)"
                  type="submit"
                  severity="primary"
                  style="border: none; margin: 10px"
                  [disabled]="!usercode || challengeSubmitted"
                >
                  Submit
                </button>
              </p-inputgroup>
            </form>
            <!-- <div class="login-page-loading-wrapper">
              <div
                class="align-center fa-2x loading-overlay"
                *ngIf="challengeSubmitted"
              >
                <scaffold-loading-animation></scaffold-loading-animation>
              </div>
            </div> -->
          </ng-container>

          <ng-container *ngIf="provideWhichMfaChallenge">
            <p>How do you want to get authenticated?</p>
            <div class="mfa-option-button-wrapper">
              <button
                class="login-page-button"
                pButton
                [disabled]="mfaSelectionMade"
                (click)="selectMfaOption('SMS_MFA')"
              >
                Text Message
              </button>
              <button
                class="login-page-button"
                pButton
                [disabled]="mfaSelectionMade"
                (click)="selectMfaOption('SOFTWARE_TOKEN_MFA')"
              >
                Authentication App
              </button>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              !provideTotbChallenge &&
              !provideWhichMfaChallenge &&
              !provideSmsChallenge
            "
          >
            <form>
              <p-inputgroup>
                <input
                  [(ngModel)]="username"
                  [ngModelOptions]="{ standalone: true }"
                  pInputText
                  [placeholder]="'username' | translation"
                />
              </p-inputgroup> 
              <br>
              <p-inputgroup>
                <input
                  [(ngModel)]="password"
                  [ngModelOptions]="{ standalone: true }"
                  pInputText
                  [placeholder]="'password' | translation"
                  [type]="hidePw ? 'text' : 'password'"
                />
                <p-inputgroup-addon>
                  <p-button [icon]="hidePw ? 'fa fa-eye' : 'fa fa-eye-slash'" severity="secondary" variant="text"
                    (click)="hidePw = !hidePw">
                  </p-button>
                </p-inputgroup-addon>
              </p-inputgroup>
              <div class="button-holder">
                <div class="text-link-color">
                  <!-- class="login-page-button"
                  pButton
                  size="tiny"
                  severity="info"
                  appearance="ghost"
                type="button" -->
                  <a routerLink="/forgot-password" class="forgot-password-link">
                    {{ "password_forgot" | translation }}?
                  </a>
                </div>
                <div>
                  <button
                    class="login-page-button"
                    pButton
                    (click)="logIn()"
                    type="submit"
                    severity="primary"
                    style="border: none"
                    [label]="'signin' | translation"
                    [disabled]="!username || !password || isWorking"
                  >
                  </button>
                </div>
                <!-- <div class="login-page-loading-wrapper">
                  <div
                    class="align-center fa-2x loading-overlay"
                    *ngIf="isWorking"
                  >
                    <scaffold-loading-animation></scaffold-loading-animation>
                  </div>
                </div> -->
              </div>
            </form>
          </ng-container>
          <div class="security-note">
            <a href="https://www.k16solutions.com/security/" target="_blank">{{
              "security_information" | translation
            }}</a>
          </div>
        </p-card-body>
      </p-card>
    </div>
  </ng-template>
</div>
